export default {
  name: 'notification',
  components: {},
  props: [],
  data () {
    return {

    }
  },
  computed: {
    notifications () {
      return this.$store.getters['Notification/getNotification']
    },
    total_notification () {
      return this.$store.getters['Profile/getTotalNotification']
    },
    noUnRead () {
      return this.$store.getters['Notification/getNoUnRead']
    }
  },
  mounted () {
  
    Promise.all([
      this.$store.dispatch('Notification/getNotification', {})
    ]).then(res => {
      
    }).catch(errors => {
      console.log(errors)
      
    })
  },
  methods: {
    readNotification (notification) {
      console.log(notification)
      this.$router.replace(notification.link)
      if (!notification.read_at) {
        this.$store.dispatch('Notification/readNotification', notification)
      }
    },
    readAll () {
      this.$store.dispatch('Profile/cleanTotalNotification')
    
      this.$store.dispatch('Notification/readAllNotification').then(res => {
        
      }).catch(errors => {
        
      })
    },
    getNotification () {
      // this.$store.dispatch('Profile/cleanTotalNotification')
      // this.$store.dispatch('Notification/readAllNotification')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/layout/notification/notification.js